module.exports = __webpack_public_path__ + "img/img2.3f3165f4.png";